import { Badge, Box, Button } from '@material-ui/core';
import { DescriptionOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { ReactComponent as ItemIcon } from 'assets/svg/items_white.svg';
import { useAuth } from 'contexts/AuthContext';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import themes from 'styles/themes';
import utils from 'utils/utils';

const useStyles = makeStyles((theme) => ({
    empty: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    img: {
        marginBottom: '30px',
    },
    h5Text: {
        fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '32px',
        lineHeight: '36px',
        textAlign: 'center',
        color: themes.palette.primary.main,
        flex: 'none',
        margin: '10px 0px',
    },
    pText: {
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '24px',
        textAlign: 'center',
        color: themes.palette.primary.main,
        flex: 'none',
        margin: '10px 0 20px 0',
    },
    inputButton: {
        border: `1px solid ${themes.palette.primary.main}`,
        borderRadius: '42px',
        width: 'auto',
        padding: '12px',
        textTransform: 'none',
        textDecoration: 'none !important',
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'center',
        color: themes.palette.primary.main,
    },
    bgIcon: {
        background: `linear-gradient(213.84deg, ${themes.palette.primary.main} 14.69%, rgba(255, 238, 179, 0) 111.22%)`,
        padding: 10,
        borderRadius: '50%',
        width: 58,
        height: 58,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

export interface StandardAlertProps {
    height: string;
    icon?: string;
    title?: string;
    body?: string;
    open?: Boolean;
    onButtonClick?: any;
    buttonClickOnWidget?: () => void;
    buttonText?: string;
    widthIcon?: string;
    heightIcon?: string;
    isIcon?: Boolean;
    iconButton?: any;
    isDocument?: any;
    isNoStyle?: any;
    isItem?: any;
    SvgIcon?: any;
}

export const StandardAlert = (props: StandardAlertProps) => {
    const { currentUser } = useAuth();
    const history = useHistory();
    const {
        height,
        icon,
        title,
        body,
        onButtonClick,
        buttonClickOnWidget,
        buttonText,
        widthIcon = '58px',
        heightIcon = '58px',
        iconButton,
        isIcon,
        isDocument,
        isItem,
        SvgIcon,
    } = props;
    const classes = useStyles();
    return (
        <div className={classes.empty} style={{ height: height }}>
            {icon || SvgIcon ? (
                isItem ? (
                    <div className={classes.bgIcon}>
                        <ItemIcon
                            style={{ color: 'white', margin: 0 }}
                            className={classes.img}
                            width={widthIcon}
                            height={heightIcon}
                        />
                    </div>
                ) : (
                    <>
                        {icon && (
                            <img src={icon} alt="" className={classes.img} width={widthIcon} height={heightIcon} />
                        )}
                        {SvgIcon && <SvgIcon />}
                    </>
                )
            ) : isDocument ? (
                <span
                    style={{
                        background: 'transparent',
                        border: `1px solid ${themes.palette.primary.main}`,
                        padding: 10,
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Badge badgeContent={0} color="error" showZero>
                        <DescriptionOutlined
                            style={{ color: themes.palette.primary.main, margin: 0 }}
                            className={classes.img}
                            width={widthIcon}
                            height={heightIcon}
                        />
                    </Badge>
                </span>
            ) : null}
            <Box className="alert-title-body-area">
                {title ? <h5 className={classes.h5Text}>{title}</h5> : null}
                {body ? (
                    <p className={classes.pText}>
                        <span dangerouslySetInnerHTML={{ __html: body }} />
                    </p>
                ) : null}
            </Box>
            {buttonText && (
                <Button
                    onClick={() => {
                        if (currentUser) onButtonClick();
                        else if (utils.isAppInWidgetMode()) {
                            if (buttonClickOnWidget) buttonClickOnWidget();
                            else history.push(PATH.SIGNUP_CUSTOMER);
                        } else history.push(PATH.LOGIN);
                    }}
                    className={classes.inputButton}
                    variant="outlined"
                >
                    {isIcon ? <img src={iconButton} alt="icon" style={{ marginRight: 10 }} /> : null}
                    {buttonText}
                </Button>
            )}
        </div>
    );
};
